import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      storeIgua.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or whether multiple notes selected
 */
export default function rnhIsBulkSelection(state = initialState.rnhIsBulkSelection, action) {
	switch (action.type) {
		case types.SET_RNH_BULK_SELECTION: {
			return action.payload;
		}
		case types.SET_RNH_MULTIPLE_NOTES_CONTEXT: {
			return action.payload;
		}
		case types.SET_RNH_SELECTED_NOTE_ID_RESET_CONTEXT: {
			return action.isBulkSelection;
		}
		case types.CLEAN_RNH_MULTIPLE_ALL_NOTES: {
			// when left rail is changed
			return false;
		}
		case types.UPDATE_RNH_MULTIPLE_NOTES_BULK_CONTEXT: {
			return action.isBulkSelection;
		}
		default:
			return state;
	}
}
